const es = {
  label: "Emparejamiento de Activos",
  tabs: {
    automatic: {
      label: "Identificado automáticamente",
    },
    automaticFailed: {
      label: "No es posible la identificación automática",
    },
    unknown: {
      label: "Objetos desconocidos",
    },
  },
};
export default es;
